<script setup lang="ts">
import {ExtendedUser} from "@/types";
import BaseLayout from "@/layouts/BaseLayout.vue";
import UserLayout from "@/Pages/users/layouts/UserLayout.vue";
import {CalendarHeatmap, Value} from "vue3-calendar-heatmap";
import {Head} from "@inertiajs/vue3";

interface Props {
    user: ExtendedUser,
    contributions: Array<Value>,
    totalContributions: number,
}

const props = defineProps<Props>()
defineOptions({
    layout: BaseLayout
})

const date = new Date().toISOString().slice(0, 10)
</script>

<template>
    <Head :title="props.user.name" />
    <user-layout
        :user="props.user"
    >
        <h1 class="font-weight-medium text-h5 mt-5">
            Transfers
        </h1>
        <v-divider class="my-5" />
        {{ props.totalContributions }} transfers in the last year
        <v-card
            min-height="150"
            max-width="680"
            variant="flat"
            class="pa-3 mt-2"
            rounded="lg"
            border="sm"
        >
            <calendar-heatmap
                :end-date="date"
                :style="{'max-width': '675px'}"
                :values="contributions"
                tooltip-unit="transfers"
                :round="2"
            />
        </v-card>
    </user-layout>
</template>

<style scoped>
#user-heatmap {
    min-height: 300px !important;
}
</style>
